import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "watchlist_item text-prediction"
}
const _hoisted_2 = {
  key: 0,
  class: "remove c-pointer"
}
const _hoisted_3 = { class: "top_card_stock_detail stock-symbol" }
const _hoisted_4 = {
  title: "watchlist.name",
  class: "no-rtl"
}
const _hoisted_5 = { class: "price right" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "top_card_stock_detail" }
const _hoisted_8 = { class: "price" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "change",
  title: "gainValue"
}
const _hoisted_11 = ["innerText"]
const _hoisted_12 = {
  key: 1,
  class: "watchlist_item watchlist_grid_item"
}
const _hoisted_13 = {
  key: 0,
  class: "remove c-pointer"
}
const _hoisted_14 = { class: "top_card_stock_detail expanded stock-symbol" }
const _hoisted_15 = {
  title: "watchlist.name",
  class: "no-rtl"
}
const _hoisted_16 = { class: "price" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "price" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 1,
  class: "change",
  title: "gainValue"
}
const _hoisted_21 = ["innerText"]
const _hoisted_22 = {
  key: 2,
  class: "watchlist_item"
}
const _hoisted_23 = { class: "top_card_stock_detail stock-symbol" }
const _hoisted_24 = {
  title: "watchlist.name",
  class: "no-rtl"
}
const _hoisted_25 = {
  key: 0,
  title: "stockData.price",
  class: "stockId"
}
const _hoisted_26 = { class: "priceTagDv text-white" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 1,
  class: "remove c-pointer"
}
const _hoisted_29 = {
  key: 0,
  class: "description"
}
const _hoisted_30 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SparklineComponent = _resolveComponent("SparklineComponent")!
  const _component_StockImageTag = _resolveComponent("StockImageTag")!

  return (_ctx.watchlist.watchlistType == 'text-prediction')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isCreateView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("i", {
                class: "fas fa-minus-circle",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeItem(_ctx.index)))
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.chartData && _ctx.gainValue)
          ? (_openBlock(), _createBlock(_component_SparklineComponent, {
              key: 1,
              data: _ctx.chartData,
              isPositive: _ctx.gainValue >= 0
            }, null, 8, ["data", "isPositive"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_StockImageTag, {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.goToStockDetail(_ctx.watchlist.symbol, _ctx.watchlist.market)), ["stop"])),
            stockData: _ctx.watchlist,
            toFixed: true,
            imgUrl: _ctx.watchlist.image ?? _ctx.watchlist.logoUrl,
            symbol: _ctx.watchlist.symbol,
            market: _ctx.watchlist.market
          }, null, 8, ["stockData", "imgUrl", "symbol", "market"]),
          _createElementVNode("p", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.goToStockDetail(_ctx.watchlist.symbol, _ctx.watchlist.market)), ["stop"]))
          }, [
            _createTextVNode(_toDisplayString(_ctx.watchlist.symbol) + " ", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.watchlist.name ?? _ctx.watchlist.companyName), 1)
          ]),
          _createElementVNode("p", _hoisted_5, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "heading" }, "Current", -1)),
            _createElementVNode("span", {
              class: "d-flex text-white",
              innerHTML: _ctx.$filters.systemNumberConventionOld(_ctx.watchlist.price, true)
            }, null, 8, _hoisted_6),
            _createElementVNode("span", null, _toDisplayString(_ctx.currentDate), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "heading" }, "Prediction", -1)),
            _createElementVNode("span", {
              class: "d-flex text-white",
              innerHTML: _ctx.$filters.systemNumberConventionOld(_ctx.watchlist.predictedPrice, true)
            }, null, 8, _hoisted_9),
            _createElementVNode("span", null, _toDisplayString(_ctx.predictionDate), 1)
          ]),
          (_ctx.gainValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(Math.abs(_ctx.gainValue)) + "% ", 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["change_chip", { bearish: _ctx.gainValue >= 0 }]),
                  innerText: _ctx.gainValue < 0 ? 'Bearish' : 'Bullish'
                }, null, 10, _hoisted_11)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_ctx.watchlist.watchlistType == 'watchlist-prediction')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_ctx.isCreateView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("i", {
                  class: "fas fa-minus-circle",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removeItem(_ctx.index)))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_StockImageTag, {
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.goToStockDetail(_ctx.watchlist.symbol, _ctx.watchlist.market)), ["stop"])),
              stockData: _ctx.watchlist,
              toFixed: true,
              imgUrl: _ctx.watchlist.image ?? _ctx.watchlist.logoUrl,
              symbol: _ctx.watchlist.symbol,
              market: _ctx.watchlist.market
            }, null, 8, ["stockData", "imgUrl", "symbol", "market"]),
            _createElementVNode("p", {
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.goToStockDetail(_ctx.watchlist.symbol, _ctx.watchlist.market)), ["stop"]))
            }, [
              _createTextVNode(_toDisplayString(_ctx.watchlist.symbol) + " ", 1),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.watchlist.name ?? _ctx.watchlist.companyName), 1)
            ])
          ]),
          _createElementVNode("p", _hoisted_16, [
            _createElementVNode("span", {
              class: "d-flex text-white",
              innerHTML: _ctx.$filters.systemNumberConventionOld(_ctx.watchlist.price, true)
            }, null, 8, _hoisted_17),
            _createElementVNode("span", null, _toDisplayString(_ctx.currentDate), 1)
          ]),
          _createElementVNode("p", _hoisted_18, [
            _createElementVNode("span", {
              class: "d-flex text-white",
              innerHTML: _ctx.$filters.systemNumberConventionOld(_ctx.watchlist.predictedPrice, true)
            }, null, 8, _hoisted_19),
            _createElementVNode("span", null, _toDisplayString(_ctx.predictionDate), 1)
          ]),
          (_ctx.gainValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createTextVNode(_toDisplayString(Math.abs(_ctx.gainValue)) + "% ", 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["change_chip", { bearish: _ctx.gainValue >= 0 }]),
                  innerText: _ctx.gainValue < 0 ? 'Bearish' : 'Bullish'
                }, null, 10, _hoisted_21)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_StockImageTag, {
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.goToStockDetail(_ctx.watchlist.symbol, _ctx.watchlist.market)), ["stop"])),
              stockData: _ctx.stockData,
              toFixed: true,
              imgUrl: _ctx.watchlist.image ?? _ctx.watchlist.logoUrl,
              symbol: _ctx.watchlist.symbol,
              market: _ctx.watchlist.market,
              stockId: _ctx.watchlist.stock_id
            }, null, 8, ["stockData", "imgUrl", "symbol", "market", "stockId"]),
            _createElementVNode("p", {
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.goToStockDetail(_ctx.watchlist.symbol, _ctx.watchlist.market)), ["stop"]))
            }, [
              _createTextVNode(_toDisplayString(_ctx.watchlist.symbol) + " ", 1),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.watchlist.name ?? _ctx.watchlist.companyName), 1)
            ]),
            (_ctx.stockData)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                  _createElementVNode("p", _hoisted_26, [
                    _createElementVNode("span", {
                      innerHTML: _ctx.$filters.systemNumberConvention(_ctx.watchlist.price, true)
                    }, null, 8, _hoisted_27)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["price__tag", 
            _ctx.stockData.changesPercentage >= 0 ||
            _ctx.stockData.changesPercentage == 'n/a'
              ? 'positive'
              : 'negative'
          ]),
                    title: "stockData.changesPercentage"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas", 
              _ctx.stockData.changesPercentage >= 0 ||
              _ctx.stockData.changesPercentage == 'n/a'
                ? 'fa-caret-up'
                : 'fa-caret-down'
            ])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(Math.abs(
              _ctx.$filters.systemNumberConvention(_ctx.stockData.changesPercentage)
            )) + "% ", 1)
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isCreateView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("i", {
                    class: "fas fa-minus-circle",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeItem(_ctx.index)))
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.watchlist.description != null && _ctx.watchlist.description != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("p", {
                  ref: "desElement",
                  class: "description_text",
                  innerHTML: _ctx.watchlist.description,
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.checkTextLength()), ["stop"]))
                }, null, 8, _hoisted_30),
                (_ctx.isTruncated)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "anchor_tag--more",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.checkTextLength(false)), ["stop"]))
                    }, "See More"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
}